import { DataGrid } from '@tableau/widgets-datagrid';
import { SiteUrls } from '@tableau/shared-urls';
import { ContentLineageRelationshipCell } from './ContentLineageRelationshipCell';

export module LinkedTaskItemSelectorGrid {
  export function columns(
    isSelected: (id: string) => boolean,
    onItemSelectionToggled: (row: DataGrid.Row) => void,
    siteUrls: SiteUrls,
  ): DataGrid.Column[] {

    const contentLineageRelationshipColumn: DataGrid.Column = {
      name: 'content-lineage-relationship-col',
      dataKey: 'contentLineageRelationship',
      sortable: false,
      growToFit: true,
      resizable: false,
      headerText: null,
      headerFormatter: null,
      cellFormatter: ContentLineageRelationshipCell(isSelected, onItemSelectionToggled, siteUrls),
    };

    return [contentLineageRelationshipColumn];
  }
}
